import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

// 주로 사용하는 color 
const opts = {
  theme: {
    themes: {
      light: {
        primary: colors.cyan,
        secondary: colors.cyan.accent3,
      },
    },
  },
};

export default new Vuetify(opts);
